import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { AdaptShellModule } from "@common/shell/shell.module";
import { AdaptToolbarModule } from "@common/shell/toolbar/toolbar.module";
import { AdaptButtonModule } from "@common/ux/button/button.module";
import { AdaptDashboardElementModule } from "@common/ux/dashboard-element/dashboard-element.module";
import { AdaptHideIfEmptyModule } from "@common/ux/hide-if-empty/hide-if-empty.module";
import { AdaptLayoutModule } from "@common/ux/layout/layout.module";
import { AdaptLinkDisabledModule } from "@common/ux/link-disabled/link-disabled.module";
import { AdaptLoadingSpinnerModule } from "@common/ux/loading-spinner/loading-spinner.module";
import { AdaptTooltipModule } from "@common/ux/tooltip.directive/tooltip.module";
import { AdaptTwoColumnModule } from "@common/ux/two-column/two-column.module";
import { AdaptUniversalDashboardElementModule } from "@common/ux/universal-dashboard-element/universal-dashboard-element.module";
import { AdaptActivityFeedModule } from "@org-common/lib/activity-feed/activity-feed.module";
import { AdaptAuthorisationModule } from "@org-common/lib/authorisation/authorisation.module";
import { AdaptDirectorySharedModule } from "@org-common/lib/directory-shared/directory-shared.module";
import { AdaptExternalDashboardModule } from "@org-common/lib/external-dashboard/external-dashboard.module";
import { AdaptFeaturesModule } from "@org-common/lib/features/features.modules";
import { AdaptGuidingPhilosophyModule } from "@org-common/lib/guiding-philosophy/guiding-philosophy.module";
import { AdaptJourneyProgressModule } from "@org-common/lib/journey-progress/journey-progress.module";
import { AdaptKanbanModule } from "@org-common/lib/kanban/kanban.module";
import { AdaptLabellingModule } from "@org-common/lib/labelling/labeling.module";
import { AdaptCommonMeetingsModule } from "@org-common/lib/meetings/common-meetings.module";
import { AdaptObjectivesModule } from "@org-common/lib/objectives/objectives.module";
import { AdaptOrganisationSharedModule } from "@org-common/lib/organisation/organisation-shared.module";
import { AdaptSurveyModule } from "@org-common/lib/survey/survey.module";
import { AdaptTeamRolesModule } from "@org-common/lib/team-roles/team-roles.module";
import { AdaptCommonTeamsModule } from "@org-common/lib/teams/common-teams.module";
import { AdaptTeamDashboardSharedModule } from "@org-common/lib/teams/team-dashboard-shared/team-dashboard-shared.module";
import { TeamDashboardSharedService } from "@org-common/lib/teams/team-dashboard-shared/team-dashboard-shared.service";
import { AdaptValuesConstitutionModule } from "@org-common/lib/values-constitution/values-constitution.module";
import { AdaptVisionModule } from "@org-common/lib/vision/vision.module";
import { AdaptOrganisationMapModule } from "app/features/architecture/organisation-map/organisation-map.module";
import { AdaptProcessMapSharedModule } from "app/features/architecture/process-map/process-map-shared.module";
import { AdaptCumulusPeerCatchupModule } from "app/features/people/peer-catchup/cumulus-peer-catchup.module";
import { AdaptTeamsModule } from "app/features/people/teams/teams.module";
import { AdaptSystemisationModule } from "app/features/systemisation/systemisation.module";
import { AdaptAppOrganisationModule } from "app/organisation/app.organisation.module";
import { AdaptEmbedShellModule } from "app/services/layout/embed-shell.module";
import { TeamDashboardPageComponent } from "./team-dashboard-page/team-dashboard-page.component";
import { teamDashboardPageRoute } from "./team-dashboard-page/team-dashboard-page.route";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        AdaptButtonModule,
        AdaptLoadingSpinnerModule,
        AdaptDirectorySharedModule,
        AdaptActivityFeedModule,
        AdaptFeaturesModule,
        AdaptShellModule,
        AdaptAuthorisationModule,
        AdaptProcessMapSharedModule,
        AdaptOrganisationMapModule,
        AdaptGuidingPhilosophyModule,
        AdaptJourneyProgressModule,
        AdaptValuesConstitutionModule,
        AdaptEmbedShellModule,
        AdaptCumulusPeerCatchupModule,
        AdaptSurveyModule,
        AdaptTeamsModule,
        AdaptObjectivesModule,
        AdaptCommonMeetingsModule,
        AdaptExternalDashboardModule,
        AdaptAppOrganisationModule,
        AdaptOrganisationSharedModule,
        AdaptTwoColumnModule,
        AdaptKanbanModule,
        AdaptSystemisationModule,
        AdaptLabellingModule,
        AdaptTeamDashboardSharedModule,
        AdaptDashboardElementModule,
        AdaptCommonMeetingsModule,
        AdaptCommonTeamsModule,
        AdaptTooltipModule,
        AdaptToolbarModule,
        AdaptTeamRolesModule,
        AdaptVisionModule,
        AdaptLayoutModule,
        AdaptHideIfEmptyModule,
        AdaptLinkDisabledModule,
        AdaptUniversalDashboardElementModule,
    ],
    declarations: [
        TeamDashboardPageComponent,
    ],
})
export class AdaptTeamDashboardModule {
    public static readonly Routes = [
        ...teamDashboardPageRoute.routes,
    ];

    public constructor(teamDashboardSharedService: TeamDashboardSharedService) {
        teamDashboardSharedService.registerTeamDashboardLinkProvider((team) => teamDashboardPageRoute.getRoute({ teamId: team.teamId }));
    }
}
